import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Copy.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "CopyIcon";
const s = e;
export {
  s as Copy,
  e as CopyIcon
};
